import React, { useState } from "react";
import { RiSendPlane2Fill } from "react-icons/ri";
import { FiSend } from "react-icons/fi";

const MessageInput = ({ onSend }) => {
    const [input, setInput] = useState("");

    const handleSend = () => {
        if (input.trim()) {
            onSend(input.trim());
            setInput("");
        }
    };

    return (
        <div style={{ display: "flex", borderTop: "1px solid #ccc", padding: "10px" }}>
            <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                style={{ flex: 1, padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize:"12px", fontWeight:"500" }}
                placeholder="Type the message ..."
            />
            <button className="send-butt-icon" onClick={handleSend} style={{ marginLeft: "8px" }}><FiSend/></button>
        </div>
    );
};

export default MessageInput;
